/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:relative}[_nghost-%COMP%]   app-reply-cell[_ngcontent-%COMP%]:first-of-type{margin-top:20px;display:block}[_nghost-%COMP%]   .replies[_ngcontent-%COMP%]{width:320px}"];
export { styles as styles };
